import { render, staticRenderFns } from "./PracticeDashboard.vue?vue&type=template&id=20e5308e"
import script from "./PracticeDashboard.vue?vue&type=script&lang=js"
export * from "./PracticeDashboard.vue?vue&type=script&lang=js"
import style0 from "./PracticeDashboard.vue?vue&type=style&index=0&id=20e5308e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports